<template>
  <div class="locationInfo">

    <div class="title">联系我们</div>
    <div class="subTitle">Contact us</div>
    <div class="itemContainer">
        <div class="item">
            <img src="tel.png"/>
            <div class="itemText">029-83333966</div>
        </div>
        <div class="item">
            <img src="location.png"/>
            <div class="itemText">陕西省西安市未央区谭家街道水晶新天地11号楼4楼</div>
        </div>

        <div class="item">
            <!-- <img src="location.png"/> -->
            <div class="itemText" @click="icpClick" style="cursor:pointer">陕ICP备2021011694号-10</div>
        </div>

        <div class="item">
            <!-- <img src="location.png"/> -->
            <div class="itemText" @click="icpClick" style="cursor:pointer">陕ICP备2021011694号-12A</div>
        </div>
    </div>

  </div>
</template>

<script>
export default {
    name: "locationInfo",
    methods: {
        icpClick(){
            window.open("https://beian.miit.gov.cn/#/Integrated/index")
        }
    }
}
</script>

<style scoped>
.locationInfo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: white;
}

.item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
img {
    width: 24px;
    height: auto;
    margin-right: 16px;
}

.itemContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    column-gap: 80px;
    margin-top: 126px;
    margin-bottom: 126px;
}

.title {
margin-top: 60px;
/** 文本1 */
font-size: 72px;
font-weight: 400;
letter-spacing: 0px;
line-height: 72px;
color: rgba(51, 51, 51, 1);
text-align: left;
vertical-align: top;

}

.subTitle {
margin-top: 16px;
/** 文本1 */
font-size: 24px;
font-weight: 400;
letter-spacing: 0px;
line-height: 24px;
color: rgba(102, 102, 102, 1);
text-align: left;
vertical-align: top;
}

.itemText {
/** 文本1 */
font-size: 24px;
font-weight: 400;
letter-spacing: 0px;
line-height: 24px;
color: rgba(102, 102, 102, 1);
text-align: left;
vertical-align: top;

}
</style>